// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__BZRJw","inner":"Footer_inner__1K-3I"};